import appConfig from "config/app";

/**
 * Okta Configuration
 *
 * This configuration is used for the Okta Sign-In Widget
 * Replace the placeholder values with your actual Okta configuration
 */

export interface OktaConfig {
  baseUri: string;
  issuer: string;
  clientId: string;
  redirectUri: string;
  scopes: Array<string>;
  features?: {
    registration?: boolean;
    rememberMe?: boolean;
    multiOptionalFactorEnroll?: boolean;
    autoPush?: boolean;
    router?: boolean;
    hideSignOutLinkInMFA?: boolean;
    mfaOnlyFlow?: boolean;
    hideDefaultLoadingState?: boolean;
    showPasswordToggleOnSignInPage?: boolean;
  };
  useInteractionCodeFlow?: boolean;
}

export const oktaConfig: OktaConfig = {
  baseUri: new URL(appConfig.oktaConfig.issuer).origin,
  issuer: appConfig.oktaConfig.issuer,
  clientId: appConfig.oktaConfig.clientId,
  redirectUri: appConfig.oktaConfig.redirectUri,
  scopes: appConfig.oktaConfig.scopes?.split(","),
  // Since we're using embedded widget without redirects, we set useInteractionCodeFlow
  useInteractionCodeFlow: true,
  features: {
    registration: false,
    rememberMe: true,
    multiOptionalFactorEnroll: false,
    autoPush: true,
    router: false,
    hideSignOutLinkInMFA: false,
    mfaOnlyFlow: false,
    hideDefaultLoadingState: false,
    showPasswordToggleOnSignInPage: true,
  },
};

export const loginCheckOktaConfig: OktaConfig = {
  baseUri: oktaConfig.baseUri,
  issuer: oktaConfig.issuer,
  clientId: appConfig.loginCheckOktaConfig.clientId,
  redirectUri: appConfig.loginCheckOktaConfig.redirectUri,
  scopes: ["openid", "profile", "email"],
  // Since we're using embedded widget without redirects, we set useInteractionCodeFlow
  useInteractionCodeFlow: true,
  features: oktaConfig.features,
};
